<template>
  <div>
    <el-row :gutter="24">
      <el-col :span="12">
        <table class="table table-xs table-hover">
          <thead>
          <tr>
            <th colspan="4" class="text-center text-danger">GENEL BİLGİLERİ</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td colspan="1">Bina Adı</td>
            <td colspan="3"><b>{{ BinaBilgi.Adi }}</b></td>
          </tr>

          <tr>
            <td width="100">Vergi Dairesi</td>
            <td width="100"><b>{{ BinaBilgi.vDairesi }}</b></td>
            <td width="100">Vergi No</td>
            <td width="100"><b>{{ BinaBilgi.vNo }}</b></td>
          </tr>

          <tr>
            <td colspan="1">Adres</td>
            <td colspan="3"><b>{{ BinaBilgi.Adres }} - {{ BinaBilgi.Sehir }}</b></td>
          </tr>
          <tr>
            <td>Sözleşme Başlangıç Tarihi</td>
            <td></td>
            <td>Sözleşme Bitiş Tarihi</td>
            <td></td>
          </tr>
          </tbody>
        </table>
        <table class="table table-xs table-hover">
          <thead>
          <tr>
            <th class="text-center text-danger">SİSTEM AYARLARI</th>
          </tr>
          </thead>
          <tbody>
          <tr>

            <td>Bina hesapları Kat malikleri ile online
              <b>{{ BinaBilgi.Online === true ? "paylaşılır" : "paylaşılmaz" }}</b>.
            </td>
          </tr>
          <tr>

            <td>Online İşlem Merkezinden kredi kartı ile online ödeme
              <b>{{ BinaBilgi.oOdeme === true ? "alınır" : "alınmaz" }}</b>.
            </td>
          </tr>
          <tr>

            <td>Kredi kartı kasalarına tahsilatlarda ilave olarak
              <b>%{{ BinaBilgi.kKomisyon }}</b> komisyon uygulanmaktadır.
            </td>
          </tr>
          <tr>

            <td>Borçlandırma esnasında belirtilen oranda gecikme zammı binada
              <b>{{ BinaBilgi.Gecikme === true ? "uygulanıyor" : "uygulanmıyor" }}</b>.
            </td>
          </tr>
          <tr>

            <td>Gecikmeler borçlandırma esnasında belirtilen son ödeme tarihinden
              <b>{{ BinaBilgi.Tolerans }}</b> gün sonra işletilmektedir.
            </td>
          </tr>
          <tr>

            <td>Son ödeme tarihini
              <b>{{ BinaBilgi.iGun }}</b> gün geçen borçlara icra uygulanabilir.
            </td>
          </tr>
          <tr>

            <td>Borçlandırma esnasında belirtilen oranda gecikme zammı
              <b>{{ BinaBilgi.tZam === true ? "aylık" : "günlük" }}</b> olarak uygulanmaktadır.
            </td>
          </tr>
          <tr>

            <td>Gecikmiş borçlarda zam uygulaması
              <b>{{ BinaBilgi.mZam }}TL</b> 'den başlamaktadır.
            </td>
          </tr>
          <tr>

            <td>Kasada bakiye olmasa dahil
              <b>{{ BinaBilgi.kLimit }}TL</b> harcama avansı vardır.
            </td>
          </tr>
          </tbody>
        </table>
        <table class="table table-xs table-hover">
          <thead>
          <tr>
            <th colspan="4" class="text-center text-danger">SGK BİLGİLERİ</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td width="100">SGK Sicil No</td>
            <td width="100"><b>{{ BinaBilgi.SGK.SicilNo }}</b></td>
            <td width="100">SGK Şube</td>
            <td width="100"><b>{{ BinaBilgi.SGK.Sube }}</b></td>
          </tr>
          <tr>
            <td rowspan="4" valign="center">SGK Şifreleri</td>
          </tr>
          <tr>
            <td>Kullanıcı Adı</td>
            <td colspan="2"><b>{{ BinaBilgi.SGK.Kullanici }}</b></td>
          </tr>
          <tr>
            <td>Sistem Şifresi</td>
            <td colspan="2"><b>{{ BinaBilgi.SGK.Sifre }}</b></td>
          </tr>
          <tr>
            <td>İşyeri Şifresi</td>
            <td colspan="2"><b>{{ BinaBilgi.SGK.iSifre }}</b></td>
          </tr>
          </tbody>
        </table>
      </el-col>
      <el-col :span="8">
        <Personel :BinaBilgi="BinaBilgi"></Personel>
        <Ilgili :BinaBilgi="BinaBilgi"></Ilgili>
        <Abonelik :BinaBilgi="BinaBilgi"></Abonelik>
        <Firma :BinaBilgi="BinaBilgi"></Firma>
        <MeskenTuru :BinaBilgi="BinaBilgi"></MeskenTuru>
      </el-col>
      <el-col :span="4">
        <el-button @click="SilOnay" type="danger" size="mini" class="btn-block" v-if="Admin">Verileri Sil</el-button>
        <Notlar :data="Notlar"></Notlar>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import Ilgili from "./Ilgili";
import Personel from "./Personel";
import Abonelik from "./Abonelik";
import Firma from "./Firma";
import MeskenTuru from "./MeskenTuru";
import Notlar from "../../../Genel/Notlar";

export default {
  components: {Notlar, MeskenTuru, Firma, Abonelik, Personel, Ilgili},
  props: {
    BinaBilgi: Object
  },
  data() {
    return {

      Yetki: null,
      Notlar: {
        Modul: 'Bina',
        Modul_id: this.BinaBilgi.id
      },

    }
  },
  methods: {
    SilOnay() {
      this.$prompt('Bu kayıttaki Mesken, Kişi, Ödeme, Tahakkuk ve bütün kayıtlar bir daha erişilememek üzere silinecektir.<br> <b class="text-danger"><i class="el-icon-warning"></i> Bu işlem geri alınamaz</b><br><br>Özel Şifreyi giriniz ', 'Verileri Silmek için onaylayınız', {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        dangerouslyUseHTMLString: true,
      }).then(({value}) => {
        if (value)
          this.Sil(value)
        else
          this.$message.error("Özel Şifre boş bırakılamaz");
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    Sil(Pk) {
      this.$alert('İşlem tamamlanana kadar bekleyiniz.', 'Bina Siliniyor', {
        confirmButtonText: 'Bekleyiniz',
        showConfirmButton: false,
      });
      //$(".el-message-box__btns button").remove();
      this.$store.dispatch("Delete", {...this.Form, path: 'yonetim/bina/' + this.BinaBilgi.id + '/' + Pk})
        .then(response => {
          if (response.Durum == "OK") {
            this.ModalOlayi = false;
            this.$message.success(response.Mesaj);

            this.BinaBilgi.Adi = 'Seçili Bina Yok';
            this.BinaBilgi.Donem = null;
            localStorage.removeItem('_aiBina');
            location.href = "/";

          } else {
            this.$message.warning(response.Mesaj);
            this.hata = response.Hata;
          }
        })

    },
  },
  created() {
    this.Yetki = this.$store.getters.Yetki.yonetim == 2 ? true : false;
    this.Admin = this.$store.getters.Admin ? true : false;
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Comp/BilgiKarti.vue